import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  //   Button,
  //   HStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // for accessing current route

import PendingTable from "./PendingTable";
import ApprovalTable from "./ApprovalTable";
import DeclinedTable from "./DeclinedTable";

import {
  fetchMemberUpgradeApps,
  setUpdateMemberUpgradeAppsStatus,
  setUpdateMemberUpgradeAppsPagination,
  setUpdateMemberUpgradeAppsPageSize,
} from "../redux/slices/membershipUpgradeSlice";

const tabStatus = ["Pending", "Approved", "Declined"];
function MembershipUpgradeTab() {
  const dispatch = useDispatch();
  const location = useLocation();

  const isIndividualRoute =
    location.pathname === "/membermanagement/individualmemberupgrade";

  const [selectedTab, setSelectedTab] = useState(0);
  //   const tabStatus = ["Pending", "Approved", "Declined"];

  const handleTabChange = (index) => {
    setSelectedTab(index);
    dispatch(setUpdateMemberUpgradeAppsStatus(tabStatus[index]));
  };

  const data = useSelector((state) => state?.membershipUpgrade);
  const memberUpgradeApps = isIndividualRoute
    ? data.individualApps
    : data.corporateApps;

  const isloading = data?.loading;
  const iserror = data?.error;

  useEffect(() => {
    // Dynamically fetch data based on route (individual or corporate)
    const route = isIndividualRoute
      ? "/individual-applications"
      : "/corporate-applications";
    dispatch(fetchMemberUpgradeApps({ route, status: tabStatus[selectedTab] }));
    // console.log(route, selectedTab);
  }, [
    dispatch,
    selectedTab,
    isIndividualRoute,
    data?.memberUpgradeAppsParams,
    // tabStatus,
  ]);

  const handlePagination = (page) => {
    dispatch(setUpdateMemberUpgradeAppsPagination({ page }));
  };

  const handlePageSize = (size) => {
    dispatch(setUpdateMemberUpgradeAppsPageSize({ size }));
  };

  const MemberUpgradeAppsData = {
    handlePagination,
    handlePageSize,
    itemsPerPage: memberUpgradeApps?.currentPageRecord,
    totalRecord: memberUpgradeApps?.totalRecord,
    pageNumber: data?.memberUpgradeAppsParams?.page,
    nextPage: memberUpgradeApps?.nextPage,
    previousPage: memberUpgradeApps?.previousPage,
    pageSize: data?.memberUpgradeAppsParams?.pageSize,
  };

  return (
    <>
      <Tabs variant="unstyled">
        <TabList gap={3} mb={3}>
          {tabStatus.map((status, index) => (
            <Tab
              key={status}
              w={"226px"}
              borderRadius={6}
              h={"50px"}
              fontSize={"14px"}
              fontWeight={400}
              onClick={() => handleTabChange(index)}
              style={
                selectedTab === index
                  ? { backgroundColor: "#22944E", color: "white" }
                  : { backgroundColor: "#E9E9E9" }
              }
            >
              {status}
            </Tab>
          ))}
        </TabList>

        <TabPanels bgColor={"white"} minH={"100vh"}>
          <TabPanel>
            <PendingTable
              memberUpgradeApps={memberUpgradeApps}
              isloading={isloading}
              iserror={iserror}
              {...MemberUpgradeAppsData}
            />
          </TabPanel>
          <TabPanel>
            <ApprovalTable
              memberUpgradeApps={memberUpgradeApps}
              isloading={isloading}
              iserror={iserror}
              {...MemberUpgradeAppsData}
            />
          </TabPanel>
          <TabPanel>
            <DeclinedTable
              memberUpgradeApps={memberUpgradeApps}
              isloading={isloading}
              iserror={iserror}
              {...MemberUpgradeAppsData}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}

export default MembershipUpgradeTab;
